var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobile)?_c('Header'):_vm._e(),(_vm.isMobile)?_c('HeaderMobile'):_vm._e(),_c('router-view'),(_vm.$route.path != '/free'&&_vm.$route.path != '/training')?_c('FooterForm'):_vm._e(),(_vm.$route.path == '/training')?_c('FooterFormTraining'):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }